export default __webpack_public_path__ + "static/mobile_section4_feature3-26fafd5590184c3d050bcac150fdfca8.png";